module.exports = __webpack_public_path__ + "static/media/home-icon.aed3ec40.svg";